const newsPressOverview = document.querySelector('.news-press-overview');
const filters =
  newsPressOverview &&
  newsPressOverview.querySelector(
    '.news-press-overview__category-filter-wrapper',
  );
const categoryOptionActiveClass = 'category-option__link--active';
const categoryFilterClickedClass = 'category-filter-clicked';

const closeFilters = () => {
  filters.classList.remove(categoryFilterClickedClass);
};

const init = () => {
  const urlSplit = window.location.pathname.split('/');
  const category = urlSplit[urlSplit.length - 1];
  const activeOption = document.querySelector(
    `.category-option__link[href$="${category}"]`,
  );
  const selected = newsPressOverview.querySelector(
    '.news-press-overview__category-active',
  );

  if (activeOption) activeOption.classList.add(categoryOptionActiveClass);
  selected.textContent = activeOption && activeOption.textContent;

  selected.addEventListener('click', (event) => {
    event.stopPropagation();
    event.target.parentNode.classList.toggle(categoryFilterClickedClass);
  });
};

(() => {
  if (newsPressOverview) {
    init();
  }
})();

if (newsPressOverview) {
  window.addEventListener('click', (event) => {
    if (!event.target.classList.contains('category-option__link')) {
      closeFilters();
    }
  });

  window.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' || event.key === 'Esc') {
      closeFilters();
    }
  });
}
